import { HorizontalDivider, Icon, Typography } from '@smartgift/frontend-toolkit';
import isEqual from 'lodash/isEqual';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { DoubleContactTable } from '../Contacts/Table';

import { EDIT_RECIPIENT_STEP, REVIEW_AND_CONFIRM_STEP } from './constant';
import * as S from './style';

function EditRecipient({
  selectedRows,
  onRequestClose,
  contactRows,
  isLiveFeature,
  onChangeSelectedRows,
  setModalObject,
  setStep,
  onNextReviewAndConfirmStep,
  featureType = 'gift',
  disabledColumns = []
}) {
  const { t } = useTranslation();

  const onNext = () => {
    if (onNextReviewAndConfirmStep) {
      return onNextReviewAndConfirmStep({
        onNext: () => setStep(REVIEW_AND_CONFIRM_STEP),
        numberOfContacts: Object.keys({ ...contactRows, ...selectedRows }).length
      });
    }

    setStep(REVIEW_AND_CONFIRM_STEP);
  };

  const handleRequestClose = () => {
    setStep(EDIT_RECIPIENT_STEP);
    onChangeSelectedRows({});
    onRequestClose();
  };

  useEffect(() => {
    const selectedRowCount = Object.keys(selectedRows).length;

    setModalObject({
      title: t(isLiveFeature ? 'addRecipients' : 'editRecipients'),
      primaryButtonProps: {
        onClick: onNext,
        children: t('next'),
        disabled: isLiveFeature
          ? selectedRowCount === 0
          : isEqual(contactRows, selectedRows) || selectedRowCount === 0,
        endIcon: <Icon name="next" />
      },
      secondaryButtonProps: {
        children: t('cancel'),
        onClick: handleRequestClose
      }
    });
  }, [isLiveFeature, contactRows, selectedRows]);

  return (
    <S.ContentWrapper>
      <Typography variant="body1Bold">
        {t(isLiveFeature ? 'recipientEditModalDescription2' : 'recipientEditModalDescription', {
          featureType: t(featureType).toLocaleLowerCase()
        })}
      </Typography>
      <HorizontalDivider $margin="16px 0" />

      <DoubleContactTable
        featureType={featureType}
        selectedRows={selectedRows}
        disabledColumns={disabledColumns}
        disabledRows={isLiveFeature && contactRows}
        onChangeSelectedRows={onChangeSelectedRows}
        translations={
          isLiveFeature
            ? {
                removeContactTitle: t('additionalRecipients'),
                removeContactTotalCountText: 'additionalTotalRecipients'
              }
            : {}
        }
      />
    </S.ContentWrapper>
  );
}

export { EditRecipient };
